import React , {useState} from "react";

import { queryClient } from '../../state/queryClient';

import { axios_contrats_updatecontrat } from "../../axios/axios_contrats";

import Boulettes from "../../Components/ContratWin/Boulettes";
import ButtonSimple from "../../Components/Buttons/ButtonSimple";

import croixclose from '../../images/croixclose.svg';


import './PopupReassigner.scss' ;
import './PopupChangeCommissionCompagnie.scss' ;

const classNames = require('classnames');
function PopupChangeCommissionCompagnie({setShowpopupchangecommissioncompagnie,listidchangestatut,setListidchange,dates}){


    const [etape, setEtape] = useState(1) ;
    const [commission_compagnie, setCommission_compagnie] = useState(0) ;


    const requalification= async() =>{
        await Promise.all( listidchangestatut.map((indexe) =>axios_contrats_updatecontrat({indexe,commission_compagnie})));        
        queryClient.invalidateQueries({queryKey: ['allcontrats',dates.date1,dates.date2]}) ;
        setListidchange([]) ;
        setShowpopupchangecommissioncompagnie(null) ; 
    }


    const recule = ()=>{setEtape(1)}
    const avance = ()=>{ etape===1? setEtape(2) : requalification() }

    const changecommission = ()=>{setCommission_compagnie(commission_compagnie=>commission_compagnie===1?0:1)}


    return(<div  className="containergray">
               <div className="ecrangestionreassigner">
               <div className="cardresilitationclose" ><img src={croixclose}  alt="imgclose" onClick={()=> setShowpopupchangecommissioncompagnie(null) }  /></div>

                <div className="ecrangestionreassigner_titre center" >Changement de Statut le la commission</div>
                <Boulettes total={3} etape={etape} />
             { etape===1 ? <> 
                <div className="ecrangestionreassigner_titre left" >Quel statut de commission voulez vous affecter à ces {listidchangestatut?.length||0} leads ?</div>  

             <div className="ecrangestionreassigner_texte">Commission </div>
             <div className="displayflex"  >
                <div className="changecommission_texte" >Non</div>
                <div className={classNames({'yescom':commission_compagnie===1} ,{'nocom':commission_compagnie!==1} )} onClick={changecommission}></div> 
                <div className="changecommission_texte" >Oui</div>
             </div>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Continuer" containerbouton='fullbutonX'  color='bouton_color_orange' size='bouton_size_normal' disable={false} onclick={avance}  />
                </div></>:<>
                <div className="ecrangestionreassigner_titre center"  >Souhaitez-vous réellement requalifier ces {listidchangestatut?.length||0} contrats?</div>
                <div  className="ecrangestionreassigner_texte center" >Cette opération est irréversible</div><br/><br/>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Retour"  color='bouton_color_blancgris' size='bouton_size_normal' disable={false} onclick={recule}  />
                    <ButtonSimple  texte="Confirmer"  color='bouton_color_orange' size='bouton_size_normal' disable={false} onclick={avance}  />
                </div></>}
               </div>
           </div>)
}


export default PopupChangeCommissionCompagnie